import { render } from "./ListPagination.vue?vue&type=template&id=2e4f7f3a"
import script from "./ListPagination.vue?vue&type=script&lang=js"
export * from "./ListPagination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__